import React from 'react';

import InlineSpinner from 'components/generic/InlineSpinner.component';

import CN from './StripeModal.module.scss';

const StripeModal = ({ children }) => (
  <div className={CN.overlay}>
    <div className={CN.modal}>
      <InlineSpinner variant="big" />
      {children}
    </div>
  </div>
);

export default StripeModal;
